export default "/images/next-btn.svg?6bf191fcfbbb80f55f6ecaca3b2e464f";